// A small reflection moves across the ink. The type itself never moves.
export function watchHomeNameMaterial(name) {
  const enabled = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const cleanups = [...name.querySelectorAll('.mono-name-typed')].map(word => {
    let bounds;
    let frame = 0;
    let lastTime = 0;
    let x = 0, y = 0, targetX = 0, targetY = 0;

    function paint() {
      word.style.setProperty('--ink-x', `${x.toFixed(2)}px`);
      word.style.setProperty('--ink-y', `${y.toFixed(2)}px`);
    }
    function settle(time) {
      frame = 0;
      const amount = 1 - Math.exp(-Math.min(time - lastTime, 32) / 60);
      lastTime = time;
      x += (targetX - x) * amount;
      y += (targetY - y) * amount;
      paint();
      if (Math.abs(targetX - x) + Math.abs(targetY - y) > .1) frame = requestAnimationFrame(settle);
    }
    function leave() {
      cancelAnimationFrame(frame);
      frame = 0;
      bounds = null;
      word.classList.remove('is-ink-lit');
    }
    function enter(event) {
      if (event.pointerType === 'touch' || !enabled.matches || !name.classList.contains('mono-name-material')) return;
      bounds = word.getBoundingClientRect();
      x = targetX = event.clientX - bounds.left;
      y = targetY = event.clientY - bounds.top;
      paint();
      word.classList.add('is-ink-lit');
    }
    function move(event) {
      if (!bounds) return;
      if (!name.classList.contains('mono-name-material')) { leave(); return; }
      targetX = event.clientX - bounds.left;
      targetY = event.clientY - bounds.top;
      if (!frame) { lastTime = performance.now(); frame = requestAnimationFrame(settle); }
    }
    word.addEventListener('pointerenter', enter);
    word.addEventListener('pointermove', move);
    word.addEventListener('pointerleave', leave);
    window.addEventListener('scroll', leave, { passive: true });
    window.addEventListener('resize', leave, { passive: true });
    enabled.addEventListener('change', leave);
    return () => {
      leave();
      word.removeEventListener('pointerenter', enter);
      word.removeEventListener('pointermove', move);
      word.removeEventListener('pointerleave', leave);
      window.removeEventListener('scroll', leave);
      window.removeEventListener('resize', leave);
      enabled.removeEventListener('change', leave);
      word.style.removeProperty('--ink-x');
      word.style.removeProperty('--ink-y');
    };
  });
  return () => cleanups.forEach(cleanup => cleanup());
}
